export const createStudentMetricsQueryFragment = (metricGroup: string, activityType: string[]) => `

${metricGroup.toLowerCase()}: studentMetrics(
  studentId: $studentIds,
  dateStart: $dateStart,
  dateEnd: $dateEnd,
  activityType: ["${activityType.join('", "')}"]
) {
    studentId
    timeRead {sum}
    sessionTime {sum}
    complianceTime {sum}
    activityCount(
      status: ["scored", "rescored"],
      activityType: ["${activityType.join('", "')}"]
    ){total}
    incompleteActivityCount: activityCount(
      status: ["in_progress", "not_started"], 
      activityType: ["${activityType.join('", "')}"]
    ){total}
}`;

export default createStudentMetricsQueryFragment;